const WEEKDAY_NAMES = [
  "Domingo",
  "Segunda-feira",
  "Terça-feira",
  "Quarta-feira",
  "Quinta-feira",
  "Sexta-feira",
  "Sábado",
];

export function isoDateToDisplayDate(isoDate: string): string {
  const [year, month, day] = isoDate.split("-");
  return `${day}/${month}/${year}`;
}

export function formatAgendaLongDate(isoDate: string): string {
  const [year, month, day] = isoDate.split("-").map(Number);
  const date = new Date(year, month - 1, day);
  const weekday = WEEKDAY_NAMES[date.getDay()];
  const monthLabel = date.toLocaleDateString("pt-BR", { month: "long" });
  return `${weekday}, ${String(day).padStart(2, "0")} de ${monthLabel}`;
}

export function formatAgendaClockNow(): string {
  return new Intl.DateTimeFormat("pt-BR", {
    timeZone: "America/Fortaleza",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date());
}

const WEEKDAY_SHORT = ["DOM", "SEG", "TER", "QUA", "QUI", "SEX", "SÁB"];

export function formatScheduleDetailHeader(
  scheduleDateTime: string,
  consultantName: string
): string {
  const parsed = new Date(scheduleDateTime.replace(" ", "T"));
  if (Number.isNaN(parsed.getTime())) {
    return consultantName.toUpperCase();
  }

  const weekday = WEEKDAY_SHORT[parsed.getDay()];
  const day = String(parsed.getDate()).padStart(2, "0");
  const month = String(parsed.getMonth() + 1).padStart(2, "0");
  const hour = String(parsed.getHours()).padStart(2, "0");
  const minute = String(parsed.getMinutes()).padStart(2, "0");

  return `${weekday} ${day}/${month} · ${hour}:${minute} · ${consultantName.toUpperCase()}`;
}

export function shiftIsoDate(isoDate: string, days: number): string {
  const [year, month, day] = isoDate.split("-").map(Number);
  const utcMs = Date.UTC(year, month - 1, day + days);
  const shifted = new Date(utcMs);
  const y = shifted.getUTCFullYear();
  const m = String(shifted.getUTCMonth() + 1).padStart(2, "0");
  const d = String(shifted.getUTCDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}
